import { useState } from 'react';
import { saveAs } from 'file-saver';

export const filenameDate = (dateObject) => {
  const d = dateObject ?? new Date();
  return d.toJSON().replace('T', '_').split('.')[0].replace(/:/g, '-');
};

export const path = (pathname, withOrigin = false) =>
  `${withOrigin ? window.location.origin : ''}${
    process.env.PUBLIC_URL
  }${pathname}`;

export const randomId = () => Math.random().toString(32).slice(2);

export const arrayMove = (array, oldIndex, newIndex) => {
  const arr = [...array];
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    // eslint-disable-next-line no-plusplus
    while (k--) {
      arr.push();
    }
  }

  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

  return arr;
};

// create your forceUpdate hook
export function useForceUpdate() {
  const setValue = useState(0)[1]; // integer state

  return () => setValue((value) => value + 1); // update the state to force render
}

export const saveCsv = (res) => {
  const blob = new Blob([res.data], {
    type: res.headers['content-type'],
  });

  saveAs(blob, `report_${filenameDate()}.csv`);

  return res;
};

export const saveXlsx = (res, filename) => {
  const blob = new Blob([res.data], {
    type: res.headers['content-type'],
  });

  const fileNameRes = filename || `download_${filenameDate()}.xlsx`;

  saveAs(blob, fileNameRes);

  return res;
};
